// Sign in with an email magic link.
import { useState, type FormEvent } from "react";
import { ApiError } from "../api";
import { Link, useSearch, useTitle } from "../lib/router";
import { requestLink } from "../session";

export function SignIn() {
  useTitle("Sign in");
  const next = useSearch().get("next") ?? "/";
  const [email, setEmail] = useState("");
  const [state, setState] = useState<"idle" | "sending" | "sent">("idle");
  const [error, setError] = useState("");
  async function submit(e: FormEvent) {
    e.preventDefault();
    setError("");
    setState("sending");
    try {
      await requestLink(email, next);
      setState("sent");
    } catch (err) {
      setError(err instanceof ApiError ? err.message : "Something went wrong. Please try again.");
      setState("idle");
    }
  }
  return (
    <main id="main" className="page narrow">
      <h1>Sign in</h1>
      {state === "sent" ? (
        <div className="panel stack" role="status">
          <p>
            We sent a sign-in link to <strong>{email}</strong>. It works once and expires in 15 minutes.
          </p>
          {import.meta.env.DEV && (
            <p className="muted">
              Development: no mail is sent — open the <Link href="/dev/mailbox">dev mailbox</Link>.
            </p>
          )}
        </div>
      ) : (
        <form className="panel stack" onSubmit={submit}>
          <p>
            No password: we email you a link. New here?{" "}
            <Link href={`/join?next=${encodeURIComponent(next)}`}>Create an account</Link>.
          </p>
          <label className="stack-label">
            <span>Email</span>
            <input
              type="email"
              required
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="signin-email"
            />
          </label>
          {error && (
            <p role="alert" className="error">
              {error}
            </p>
          )}
          <button className="btn btn-primary" disabled={state === "sending"} data-testid="signin-submit">
            {state === "sending" ? "Sending…" : "Email me a sign-in link"}
          </button>
        </form>
      )}
    </main>
  );
}
